import CommonInformationDetail from '../../../common/pages/secure/InformationDetail'
import Config from '../../../Config'

class InformationDetail extends CommonInformationDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.adminApiUrl.systemSettings
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
    this.isShowingEditButton = true
    this.isShowingDeleteButton = true
  }
}

export default InformationDetail



// WEBPACK FOOTER //
// ./src/admin/pages/secure/InformationDetail.js